import FlowType from "../../commons/model/FlowType";
import { DropdownOption } from "../../commons/components/dropdown/Dropdown";

const fullAssessmentOption = {
  name: i18n["Page.Settings.Customisation.Flow.Integration.Modal.Flow.FullAssessment"],
  value: FlowType.FULL_ASSESSMENT,
};

const smileAssessmentOption = {
  name: i18n["Page.Settings.Customisation.Flow.Integration.Modal.Flow.SmileAssessment"],
  value: FlowType.SMILE_ASSESSMENT,
};

const smileSimulationOption = {
  name: i18n["Page.Settings.Customisation.Flow.Integration.Modal.Flow.SmileSimulation"],
  value: FlowType.SMILE_SIMULATION,
};

export const FLOWS_DROPDOWN_OPTIONS: DropdownOption[] = [
  fullAssessmentOption,
  smileAssessmentOption,
  smileSimulationOption,
];

export const getDropdownValue = (flowType: FlowType) =>
  FLOWS_DROPDOWN_OPTIONS.find((opt) => opt.value === flowType);
